import React, { FC } from 'react';

interface IProps {
  width?: number;
  height?: number;
  color: string;
}

const AiIcon: FC<IProps> = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
      d="M11.9998 23C11.5417 23 11.1289 22.724 10.9534 22.301C8.72423 16.9186 7.08098 15.2754 1.69862 13.0466C1.27563 12.8715 1 12.4583 1 12.0006C1 11.5421 1.27602 11.1296 1.69862 10.9542C7.08137 8.72423 8.72462 7.08098 10.9534 1.6994C11.1289 1.27602 11.5417 1 11.9998 1C12.4579 1 12.8707 1.27602 13.0462 1.6994C15.2758 7.08137 16.919 8.72462 22.3014 10.9542C22.7244 11.1296 23 11.5421 23 12.0006C23 12.4583 22.724 12.8715 22.301 13.0466C16.9186 15.2754 15.2758 16.919 13.0458 22.301C12.8707 22.724 12.4579 23 11.9998 23Z"
    />
  </svg>
);

export { AiIcon };
